import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      padding: '1.4rem',
    },
    headerTitle: {
      height: '40px',
      marginBottom: '0.5rem',
    },
    headerSubtitle: {
      height: '20px',
    },
  },
  sorting: {
    height: '40px',
    marginTop: '1.5rem',
    float: 'right',
  },
  list: {
    marginTop: '1.5rem',
  },
  fareItem: {
    main: {
      marginBottom: '0.5rem',
    },
    box: {
      padding: '1.5rem',
    },
    title: {
      height: '30px',
      marginBottom: '1rem',
    },
    subtitle: {
      height: '20px',
    },
    button: {
      height: '30px',
      float: 'right',
    },
  },
  loadMore: {
    height: '40px',
    marginTop: '1.5rem',
  },
  disclaimer: {
    height: '20px',
    marginTop: '0.25rem',
  },
};

const SkeletonFareListTwoColumnsMobile = (props) => {
  const { header, sorting, list, fareItem, loadMore, disclaimer } = styles;
  const [className, style] = useStyles(props);
  return (
    <Box
      className={`${className} fr-skeleton`}
      dataTestId="skeletonFareListContainerMobile"
      style={style}
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={header.main}>
            <Col xs="10" className="fr-skeleton-element" style={header.headerTitle} />
            <Col xs="9" className="fr-skeleton-element" style={header.headerSubtitle} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col className="fr-skeleton-element" style={sorting} />
        </Col>
      </Row>
      <Row style={list}>
        <Col xs="12" style={fareItem.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
            <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
            <Col xs="7" className="fr-skeleton-element" style={fareItem.subtitle} />
            <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
          </Box>
        </Col>
        <Col xs="12" style={fareItem.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={fareItem.box}>
            <Col xs="6" className="fr-skeleton-element" style={fareItem.title} />
            <Col xs="7" className="fr-skeleton-element" style={fareItem.subtitle} />
            <Col xs="4" className="fr-skeleton-element" style={fareItem.button} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col className="fr-skeleton-box" style={disclaimer} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col className="fr-skeleton-element" style={loadMore} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFareListTwoColumnsMobile.componentName = 'SkeletonFareListTwoColumnsMobile';

export default SkeletonFareListTwoColumnsMobile;
